import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGameApi = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    height: '100%',
    position: 'relative',
    overflow: 'visible',
    'body': {
        background: '#fff'
    },

    [theme.breakpoints.down('md')]: {},
}));

export default StyledGameApi;
